import React from 'react';
import TopNavbar from '../home/TopNavbar';

const styles = `
    /* General body and container styling */
  

    .container {
        max-width: 1200px;
        margin: auto;
        background-color: #fff;
        padding: 10px;
        border-radius: 10px;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        padding-bottom: 100px;
         margin-top:30px;
    }

    /* Heading styles */
    .main-heading {
     padding-top:50px;
        color: #1a237e; /* Dark blue */
        text-align: center;
        font-size: 1.5em;
        margin-bottom: 10px;
        border-bottom: 3px solid #1a237e;
        padding-bottom: 10px;
    }

    .sub-heading {
        color: #283593; /* Slightly lighter blue */
        font-size: 2em;
        margin-top: 40px;
        margin-bottom: 15px;
    }

    .table-heading {
        color: #3949ab; /* Another shade of blue */
        font-size: 1.5em;
        margin-top: 30px;
        margin-bottom: 10px;
    }

    .sub-table-heading {
        color: #3f51b5; /* Lighter blue */
        font-size: 1.2em;
        margin-top: 25px;
        margin-bottom: 10px;
        text-transform: uppercase;
    }

    /* Paragraph styles */
    .intro-paragraph, .section-paragraph {
        font-size: 1em;
        text-align: justify;
        margin-bottom: 20px;
    }

    /* Table styles */
    table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 20px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }

    th, td {
        padding: 12px;
        text-align: left;
        border: 1px solid #ddd;
    }

    thead th {
        background-color: #1a237e; /* Dark blue for table headers */
        color: #fff;
        font-weight: bold;
        text-transform: uppercase;
    }

    /* Alternating row colors for better readability */
    tbody tr:nth-child(even) {
        background-color: #e8eaf6; /* Light purple-blue */
    }

    tbody tr:nth-child(odd) {
        background-color: #f1f3f9; /* Even lighter purple-blue */
    }

    /* Hover effect on table rows */
    tbody tr:hover {
        background-color: #c5cae9; /* A slightly darker blue on hover */
        transition: background-color 0.3s ease;
    }

    /* Styling for the total row */
    tbody tr:last-child {
        font-weight: bold;
        background-color: #bbdefb !important; /* A light, distinct blue for the total row */
    }

    tbody tr:last-child td {
        border-top: 2px solid #1a237e;
    }
`;

const PhysicsData = [
    { class: "11th", chapter: "Mechanical Properties of Fluids", questions: 1 },
    { class: "11th", chapter: "Laws of Motion", questions: 1 },
    { class: "11th", chapter: "Work, Energy and Power", questions: 1 },
    { class: "11th", chapter: "Circular Motion", questions: 1 },
    { class: "11th", chapter: "Center of Mass and System of Particles", questions: 1 },
    { class: "11th", chapter: "Kinetic Theory", questions: 1 },
    { class: "11th", chapter: "Motion in a Straight Line", questions: 2 },
    { class: "11th", chapter: "Rotational Motion", questions: 3 },
    { class: "11th", chapter: "Thermal Properties of Matter", questions: 1 },
    { class: "11th", chapter: "Oscillations", questions: 2 },
    { class: "11th", chapter: "Units and Measurements", questions: 3 },
    { class: "11th", chapter: "Thermodynamics", questions: 2 },
    { class: "11th", chapter: "Gravitation", questions: 2 },
    { class: "11th", chapter: "Waves", questions: 1 },
    { class: "12th", chapter: "Ray Optics and Optical Instruments", questions: 2 },
    { class: "12th", chapter: "Moving Charges and Magnetism", questions: 3 },
    { class: "12th", chapter: "Current Electricity", questions: 3 },
    { class: "12th", chapter: "Semiconductor Electronics: Materials, Devices and Simple Circuits", questions: 2 },
    { class: "12th", chapter: "Electromagnetic Waves", questions: 2 },
    { class: "12th", chapter: "Electromagnetic Induction", questions: 1 },
    { class: "12th", chapter: "Alternating Current", questions: 1 },
    { class: "12th", chapter: "Electrostatic Potential and Capacitance", questions: 2 },
    { class: "12th", chapter: "Wave Optics", questions: 2 },
    { class: "12th", chapter: "Electric Charges and Fields", questions: 1 },
    { class: "12th", chapter: "Atoms", questions: 2 },
    { class: "12th", chapter: "Dual Nature of Radiation and Matter", questions: 2 },
];

const renderTable = (data) => (
    <table>
        <thead>
            <tr>
                <th>Class</th>
                <th>Chapter Name</th>
                <th>No. of Questions</th>
            </tr>
        </thead>
        <tbody>
            {data.map((item, index) => (
                <tr key={index}>
                    <td>{item.class}</td>
                    <td>{item.chapter}</td>
                    <td>{item.questions}</td>
                </tr>
            ))}
            <tr>
                <td colSpan="2"><strong>Total</strong></td>
                <td><strong>{data.reduce((sum, item) => sum + item.questions, 0)}</strong></td>
            </tr>
        </tbody>
    </table>
);

const NeetWeightagePhysics = () => {
    return (
        <div>
            <style>{styles}</style>
            <div className="container">
                <TopNavbar name="Physics Weightage" />
                <h1 className="main-heading">Physics Chapter-wise Weightage in NEET 2025 Paper</h1>
                <p className="intro-paragraph">
                    The Chapter-wise NEET 2025 Paper Analysis for Physics examines the distribution and difficulty level of questions across various sections of the syllabus. It provides an in-depth review of the questions' complexity, helping students identify which areas were more challenging and which were easier. This analysis guides aspirants in prioritizing their preparation and focusing on areas that require more in-depth study.
                </p>

                <h3 className="table-heading">Chapter Wise NEET Weightage for Physics</h3>
                {renderTable(PhysicsData)}
            </div>
        </div>
    );
};

export default NeetWeightagePhysics;